// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RNoNXsn3P5ljLNObBcvb{
    display: flex;
    flex-direction: column;
    overflow: hidden;
    align-items: center;
    color: var(--letter-dark);
    padding: 5px;
    box-sizing: border-box;
    height: 100%;
    display: flex;
    padding: 10px 0px 0px 0px;

}

.lsx1k1seFXIxUuTIgJBO, ._D4G4wOpQ6mEv1m12Ozw{
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    box-sizing: border-box;
    padding: 0px;
    overflow: hidden;
    flex: 0 0 auto;
    margin-top: 4px;
    margin-bottom: 4px;
    color: var(--icons);
    padding: 0px;
}
.lsx1k1seFXIxUuTIgJBO{
    border: none;
    height: 40px;
}
._D4G4wOpQ6mEv1m12Ozw{
    border: 1px solid var(--border-medium);
    height: 32px;
}

.w4nrPjWW8ep3tKCdSZdD{
    font-size: 24px;
    color: var(--icons);
    cursor: pointer;
}

.w4nrPjWW8ep3tKCdSZdD:hover{
    color: var(--icons);
    border: 1px solid var(--border-medium);
    border-radius: 16px;
}

.Y4RfsV5DoUWLAoKAwI1n{
    display: flex;
    align-items: center;
    flex-direction: row;
    text-align: left;
    padding-left: 5px;
    font-size: 16px;
    height: 20px;
    color: var(--letter-dark);
}

.XDck8kHzDDpSxyFWFl0V{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    flex-grow: 1;
    overflow-y: auto;
    list-style-type: none;
    padding-left: 16px;
    margin-top: 2px;
    margin-bottom: 0px;
    box-sizing: border-box;
    height: 100%;
}

.XDck8kHzDDpSxyFWFl0V::-webkit-scrollbar {
    width: 4px;
}

.XDck8kHzDDpSxyFWFl0V::-webkit-scrollbar-track {
    background: transparent; /* Color of the scrollbar track */
}

.XDck8kHzDDpSxyFWFl0V::-webkit-scrollbar-thumb {
    background-color: var(--scrollbar-regular); /* Color of the scrollbar itself */
}

.XDck8kHzDDpSxyFWFl0V::-webkit-scrollbar-thumb:hover {
    background-color: var(--scrollbar-hover); /* Color on hover */
}

.XDck8kHzDDpSxyFWFl0V::-webkit-scrollbar-thumb:active {
    background-color: var(--scrollbar-onClick); /* Color on click */
}

.XDck8kHzDDpSxyFWFl0V::-webkit-scrollbar-corner {
    background-color: transparent; /* Set the corner color to match your design */
}`, "",{"version":3,"sources":["webpack://./clientRoot/Static/WorkingArea/ServiceOrdersTab/ServiceOrdersTab.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,yBAAyB;;AAE7B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;;IAEvB,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,YAAY;IACZ,YAAY;AAChB;AACA;IACI,sCAAsC;IACtC,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB,EAAE,iCAAiC;AAC9D;;AAEA;IACI,0CAA0C,EAAE,kCAAkC;AAClF;;AAEA;IACI,wCAAwC,EAAE,mBAAmB;AACjE;;AAEA;IACI,0CAA0C,EAAE,mBAAmB;AACnE;;AAEA;IACI,6BAA6B,EAAE,8CAA8C;AACjF","sourcesContent":[".serviceOrdersTab{\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    align-items: center;\n    color: var(--letter-dark);\n    padding: 5px;\n    box-sizing: border-box;\n    height: 100%;\n    display: flex;\n    padding: 10px 0px 0px 0px;\n\n}\n\n.workspace, .selectors{\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n\n    box-sizing: border-box;\n    padding: 0px;\n    overflow: hidden;\n    flex: 0 0 auto;\n    margin-top: 4px;\n    margin-bottom: 4px;\n    color: var(--icons);\n    padding: 0px;\n}\n.workspace{\n    border: none;\n    height: 40px;\n}\n.selectors{\n    border: 1px solid var(--border-medium);\n    height: 32px;\n}\n\n.serviceOrderIcon{\n    font-size: 24px;\n    color: var(--icons);\n    cursor: pointer;\n}\n\n.serviceOrderIcon:hover{\n    color: var(--icons);\n    border: 1px solid var(--border-medium);\n    border-radius: 16px;\n}\n\n.serviceOrdersLabel{\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    text-align: left;\n    padding-left: 5px;\n    font-size: 16px;\n    height: 20px;\n    color: var(--letter-dark);\n}\n\n.serviceOrdersArea{\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    flex-grow: 1;\n    overflow-y: auto;\n    list-style-type: none;\n    padding-left: 16px;\n    margin-top: 2px;\n    margin-bottom: 0px;\n    box-sizing: border-box;\n    height: 100%;\n}\n\n.serviceOrdersArea::-webkit-scrollbar {\n    width: 4px;\n}\n\n.serviceOrdersArea::-webkit-scrollbar-track {\n    background: transparent; /* Color of the scrollbar track */\n}\n\n.serviceOrdersArea::-webkit-scrollbar-thumb {\n    background-color: var(--scrollbar-regular); /* Color of the scrollbar itself */\n}\n\n.serviceOrdersArea::-webkit-scrollbar-thumb:hover {\n    background-color: var(--scrollbar-hover); /* Color on hover */\n}\n\n.serviceOrdersArea::-webkit-scrollbar-thumb:active {\n    background-color: var(--scrollbar-onClick); /* Color on click */\n}\n\n.serviceOrdersArea::-webkit-scrollbar-corner {\n    background-color: transparent; /* Set the corner color to match your design */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"serviceOrdersTab": `RNoNXsn3P5ljLNObBcvb`,
	"workspace": `lsx1k1seFXIxUuTIgJBO`,
	"selectors": `_D4G4wOpQ6mEv1m12Ozw`,
	"serviceOrderIcon": `w4nrPjWW8ep3tKCdSZdD`,
	"serviceOrdersLabel": `Y4RfsV5DoUWLAoKAwI1n`,
	"serviceOrdersArea": `XDck8kHzDDpSxyFWFl0V`
};
export default ___CSS_LOADER_EXPORT___;
